var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getPage)?_c('div',[_c('Banner',{attrs:{"page":_vm.getPage}}),_c('section',{staticClass:"description events-page-wrap clearfix"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('section',{staticClass:"col-md-12",domProps:{"innerHTML":_vm._s(_vm.getPage.details)}})])])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }